module.exports = __webpack_public_path__ + "img/gs00.59246594.jpg";